import React from 'react'
import RequireAuth from "./RequireAuth";
import { AccessDenied } from "./RequireDeveloper";
import { isStaff } from "./scope";

// Pages for WPL staff (employee and developer scopes) only.
export default function RequireStaff({ children, ...authProps }) {
    if (!isStaff()) return <AccessDenied message='This page is only available to Windpower Lab staff.' />

    return <RequireAuth {...authProps}>{children}</RequireAuth>
}
